<template>
  <div class="d-flex align-items-center justify-content-center">
    <div class="alert border-0 border-start border-5 alert-dismissible fade show mb-0 card mb-2" :class="'border-' + type">
      <div class="card-body p-0">
        <div>{{ message }}</div>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Zavřít"></button>
      </div>
    </div>
  </div>
</template>

<script>
import {reactive, toRefs} from 'vue';

export default {
  name: 'FlashMessage',
  props: {
    type: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  setup() {
    const data = reactive({
      count: 0,
    });

    return {
      ...toRefs(data),
    }
  }
}
</script>

<style scoped>

</style>